import React, { useState, useEffect } from 'react';
import { Mentions, Spin } from 'antd';
import { UsersService } from '../api/services/users.service';
import { TasksService } from '../api/services/tasks.service';
import { ProjectsService } from '../api/services/projects.service';

let cachedUsers = null;
let cachedTasks = null;
let cachedProjects = null;
let fetchingPromise = null;

export default function SmartMentionsInput(props) {
  const [dataLoaded, setDataLoaded] = useState(!!(cachedUsers && cachedTasks && cachedProjects));
  const [currentPrefix, setCurrentPrefix] = useState('@');

  useEffect(() => {
    if (!dataLoaded) {
      if (!fetchingPromise) {
        fetchingPromise = Promise.all([
          UsersService.getUsers().catch(() => ({ data: [] })),
          TasksService.getTasks().catch(() => ({ data: [] })),
          ProjectsService.getProjects().catch(() => ({ data: [] }))
        ]).then(([usersRes, tasksRes, projectsRes]) => {
          cachedUsers = usersRes.data || [];
          cachedTasks = tasksRes.data || [];
          cachedProjects = projectsRes.data || [];
          return true;
        });
      }
      fetchingPromise.then(() => {
        setDataLoaded(true);
      });
    }
  }, [dataLoaded]);

  const onSearch = (_, prefix) => {
    setCurrentPrefix(prefix);
  };

  const getOptions = () => {
    if (!dataLoaded) return [];
    if (currentPrefix === '@') {
      return cachedUsers
        .map(u => ({ value: String(u.full_name || u.email || u.id), label: String(u.full_name || u.email || u.id), key: `u_${u.id}` }))
        .filter(opt => opt.value);
    }
    if (currentPrefix === '#') {
      return cachedTasks
        .map(t => ({ value: String(t.title || t.id), label: String(t.title || t.id), key: `t_${t.id}` }))
        .filter(opt => opt.value);
    }
    if (currentPrefix === '$') {
      return cachedProjects
        .map(p => ({ value: String(p.name || p.id), label: String(p.name || p.id), key: `p_${p.id}` }))
        .filter(opt => opt.value);
    }
    return [];
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      if (props.onSubmit) {
        e.preventDefault();
        props.onSubmit();
      }
    }
    if (props.onKeyPress) {
      props.onKeyPress(e);
    }
  };

  return (
    <Mentions
      {...props}
      prefix={['@', '#', '$']}
      onSearch={onSearch}
      options={getOptions()}
      notFoundContent={dataLoaded ? "Не найдено" : <Spin size="small" />}
      onKeyPress={handleKeyPress}
    />
  );
}